module.exports = __webpack_public_path__ + "static/img/biaoji.b03d329.png";


//////////////////
// WEBPACK FOOTER
// ./static/biaoji.png
// module id = 7ZHI
// module chunks = 1